import React from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'

import queryClient from './helpers/queryClient'
import './i18n'
import './helpers/posthog'
import './helpers/sentry'
import './MSTeams/api/sharedClient'

import MSTeamsApp from '@msteams/App'

import 'react-datepicker/dist/react-datepicker.css'
import '@szhsin/react-menu/dist/index.css'
import '@szhsin/react-menu/dist/transitions/slide.css'

import './index.css'

const MSTeamsAppCmp = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <MSTeamsApp />
    </QueryClientProvider>
  </React.StrictMode>
)

const root = createRoot(document.getElementById('root')!)

root.render(MSTeamsAppCmp)
